import { render, staticRenderFns } from "./CreateOrAddUsersToGroup.vue?vue&type=template&id=60b1dcfa&scoped=true"
import script from "./CreateOrAddUsersToGroup.vue?vue&type=script&lang=js"
export * from "./CreateOrAddUsersToGroup.vue?vue&type=script&lang=js"
import style0 from "./CreateOrAddUsersToGroup.vue?vue&type=style&index=0&id=60b1dcfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b1dcfa",
  null
  
)

export default component.exports